import type { FormikHandlers, FormikHelpers } from 'formik';
import { Text } from '@rsos/base-components';
import { Box } from '@rsos/components/capstone/base';
import InputText from '@rsos/components/capstone/base/form/inputs/InputText';
import { Label } from '../AirAmbulanceForm/AirAmbulanceFormStandalone.styles';

interface LabeledInputProps {
  label: string;
  name: string;
  value: string;
  setFieldValue: FormikHelpers<unknown>['setFieldValue'];
  onChange: FormikHandlers['handleChange'];
  onBlur: FormikHandlers['handleBlur'];
  placeholder?: string;
}

/**
 * The labeled input component used in the Air Ambulance Edit Form.
 */
export function LabeledInput({
  label,
  name,
  value,
  setFieldValue,
  onChange,
  onBlur,
  placeholder,
}: LabeledInputProps): JSX.Element {
  return (
    <Box pb={3}>
      <Label>
        <Text size="small" color="primaryText">
          {label}
        </Text>
      </Label>
      <InputText
        name={name}
        value={value}
        setFieldValue={setFieldValue}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
      />
    </Box>
  );
}
